export interface ExternalLinkConfig {
  id: string;
  name: string;
  href: string;
  network: string; // For react-social-icons
  enabled: boolean;
  tooltip?: string;
  openInNewTab?: boolean;
}

// Default external links configuration
const defaultExternalLinks: ExternalLinkConfig[] = [
  {
    id: "github",
    name: "GitHub",
    href: "https://github.com/plusefin",
    network: "github",
    enabled: false,
    tooltip: "View our GitHub repository",
    openInNewTab: true,
  },
  {
    id: "discord",
    name: "Discord",
    href: "https://discord.gg/your-server",
    network: "discord",
    enabled: false,
    tooltip: "Join our Discord community",
    openInNewTab: true,
  },
  {
    id: "telegram",
    name: "Telegram",
    href: "https://t.me/plusefin",
    network: "telegram",
    enabled: false,
    tooltip: "Follow us on Telegram",
    openInNewTab: true,
  },
  {
    id: "reddit",
    name: "Reddit",
    href: "https://www.reddit.com/r/plusefin/",
    network: "reddit",
    enabled: false,
    tooltip: "Follow us on Reddit",
    openInNewTab: true,
  },
];

// Function to get external links with environment variable overrides
export function getExternalLinksConfig(): ExternalLinkConfig[] {
  return defaultExternalLinks.map(link => {
    const envKey = `VITE_${link.id.toUpperCase()}_URL`;
    const envUrl = import.meta.env[envKey];
    
    return {
      ...link,
      href: envUrl || link.href,
      enabled: Boolean(envUrl) || link.enabled, // Enable if env var is set OR if enabled by default
    };
  });
}

// Function to get only enabled external links
export function getEnabledExternalLinks(): ExternalLinkConfig[] {
  return getExternalLinksConfig().filter(link => link.enabled);
}

// Function to add custom external links (for future extensibility)
export function addCustomExternalLink(link: Omit<ExternalLinkConfig, 'id'>): ExternalLinkConfig {
  return {
    ...link,
    id: link.name.toLowerCase().replace(/\s+/g, '-'),
  };
}